import React from "react";
import { MotiView } from "moti";
import { Users, ChatCircle, Clock, Question } from "@phosphor-icons/react";

import { StatCard } from "../../../components/adminDashboard/AICompanion";
import { colors, spacing } from "../../../styles/design-system";
import { View, StyleSheet, Text } from "react-native";

type Props = {
  totalUsers: number;
  totalSessions: number;
  avgSessionLength: string;
};

export default function AdminStatsCards({ totalUsers, totalSessions, avgSessionLength }: Props) {
  // Temporary mock data until backend exists
  const assignmentQuestions = 330;
  const courseQuestions = 308;
  const questionsAnswered = assignmentQuestions + courseQuestions;

  return (
    <MotiView
      from={{ opacity: 0, translateY: 20 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ type: "timing", duration: 500, delay: 100 }}
      style={styles.statsGrid}>
      <StatCard
        title="Total Users"
        value={totalUsers.toLocaleString()}
        change=""
        changeType="positive"
        icon={Users}
        color="blue"
      />

      <StatCard
        title="Total Sessions"
        value={totalSessions.toLocaleString()}
        change=""
        changeType="positive"
        icon={ChatCircle}
        color="purple"
      />

      <StatCard
        title="Avg. Session Length"
        value={avgSessionLength}
        change=""
        changeType="positive"
        icon={Clock}
        color="green"
      />
      {/* will be implemented in the future when the backend is ready. */}
      {/* <StatCard
        title="Questions Answered"
        value={questionsAnswered.toLocaleString()}
        change=""
        changeType="positive"
        icon={Question}
        color="blue"
        footer={
          <View style={styles.footerInline}>
            <View style={styles.footerRow}>
              <Text style={styles.footerText}>{assignmentQuestions} assignment</Text>
            </View>

            <View style={styles.footerRow}>
              <Text style={styles.footerDot}>·</Text>
              <Text style={styles.footerText}>{courseQuestions} course</Text>
            </View>
          </View>
        }
      /> */}
    </MotiView>
  );
}
const styles = StyleSheet.create({
  footerInline: {
    flexDirection: "row",
    flexWrap: "wrap",
    columnGap: 12,
    rowGap: 4,
    alignItems: "center",
  },
  footerRow: {
    flexDirection: "row",
    alignItems: "baseline",
  },

  footerText: {
    fontSize: 12,
    color: colors.grey[600],
  },

  footerDot: {
    fontSize: 12,
    color: colors.grey[400],
    marginHorizontal: 6,
    lineHeight: 12,
  },

  statsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.lg,
    marginBottom: spacing.xl,
    alignItems: "flex-start",
  },
});
